module.exports = __webpack_public_path__ + "static/media/forward-menu.a318802c.png";